import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  dataTableLanguage: DataTables.LanguageSettings = {
    emptyTable: 'Nenhum registro encontrado',
    info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
    infoEmpty: 'Mostrando 0 até 0 de 0 registros',
    infoFiltered: '',
    infoPostFix: '',
    decimal: ',',
    thousands: '.',
    lengthMenu: '_MENU_ resultados por página',
    loadingRecords: 'Carregando...',
    processing: 'Processando...',
    search: 'Pesquisar',
    searchPlaceholder: '',
    zeroRecords: 'Nenhum registro encontrado',
    paginate: {
      first: 'Primeiro',
      last: 'Último',
      next: 'Próximo',
      previous: 'Anterior',
    },
    aria: {
      sortAscending: ': Ordenar colunas de forma ascendente',
      sortDescending: ': Ordenar colunas de forma descendente',
      paginate: {
        first: 'Primeiro',
        last: 'Último',
        next: 'Próximo',
        previous: 'Anterior',
      },
    },
    url: '',
  };

  requestOptions = {};

  redirectUrl!: any;

  constructor(private http: HttpClient) {
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    };

    this.requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
  }

  internalStringToInt(value: string | string[]) {
    return Number(value);
  }

  internalStringToString(value: string | string[]) {
    return value as string;
  }

  internalStringToArrayString(value: string | string[]) {
    return value as string[];
  }

  auth(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'login',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  logout() {
    return this.http.post<any>(
      environment.apiEndpoint + 'logout',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  alterarSenha(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'alterar-senha',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  recuperarSenha(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'recuperar-senha',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  cadastrarEscritorio(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-escritorio',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchEscritorio(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-escritorio',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  editarEscritorio(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'editar-escritorio',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  excluirEscritorio(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'excluir-escritorio',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  cadastrarColaborador(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-colaborador',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchColaborador(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-colaborador',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  editarColaborador(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'editar-colaborador',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  excluirColaborador(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'excluir-colaborador',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  cadastrarTemplate(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-template',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchTemplate(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-template',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  editarTemplate(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'editar-template',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  excluirTemplate(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'excluir-template',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  cadastrarPedido(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-pedido',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  cadastrarPedidoAnalise(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-analise',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchLog(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogAnalise(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'analise-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownload(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-pedido',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  cadastrarRetificacaoDCTF(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-retificacao-dctf',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchLogRetificacaoDCTF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'retificacao-dctf-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadRetificacaoDCTF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-retificacao-dctf',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogRetificacaoEFD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'retificacao-efd-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadRetificacaoEFD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-retificacao-efd',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogRetificacaoECD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'retificacao-ecd-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadRetificacaoECD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-retificacao-ecd',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogRetificacaoECF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'retificacao-ecf-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadRetificacaoECF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-retificacao-ecf',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogRetificacaoICMS(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'retificacao-icms-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadRetificacaoICMS(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-retificacao-icms',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadDCOMP1() {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-modelo-dcomp1',
      this.requestOptions
    );
  }

  cadastrarDCOMP1(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-dcomp1',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchLogDCOMP1(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'dcomp1-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoEFD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-efd-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoEFD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-efd',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoECD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-ecd-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoECD(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-ecd',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoECF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-ecf-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoECF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-ecf',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoICMS(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-icms-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoICMS(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-icms',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoDCTF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-dctf-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoDCTF(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-dctf',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoNFe(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-nfe-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoNFe(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-nfe',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoCTe(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-cte-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoCTe(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-cte',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchLogImportacaoCFe(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'importacao-cfe-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadImportacaoCFe(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-importacao-cfe',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDownloadDCOMP2() {
    return this.http.post<any>(
      environment.apiEndpoint + 'download-modelo-dcomp2',
      this.requestOptions
    );
  }

  cadastrarDCOMP2(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-dcomp2',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchLogDCOMP2(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'dcomp2-buscar-log',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  cadastrarTag(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-tag',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchTag(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-tag',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  editarTag(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'editar-tag',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  excluirTag(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'excluir-tag',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchDashboard(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-dashboard',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  checarScan(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'checar-scan',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  cadastrarLista(id: Number, nome: string) {
    return this.http.post<any>(
      environment.apiEndpoint + 'cadastrar-lista',
      JSON.stringify({ id, nome }),
      this.requestOptions
    );
  }

  renomearLista(id: Number, nome: string) {
    return this.http.post<any>(
      environment.apiEndpoint + 'renomear-lista',
      JSON.stringify({ id, nome }),
      this.requestOptions
    );
  }

  excluirLista(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'excluir-lista',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  transferirItem(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'transferir-item',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  moverItem(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'mover-item',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchAtividade(id: number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-atividade',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  fetchIdentificacao(id: number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-identificacao',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  inserirComentario(id: number, comentario: string) {
    return this.http.post<any>(
      environment.apiEndpoint + 'inserir-comentario',
      JSON.stringify({ id, comentario }),
      this.requestOptions
    );
  }

  atualizarTags(id: number, tags: string[]) {
    return this.http.post<any>(
      environment.apiEndpoint + 'atualizar-tags',
      JSON.stringify({ id, tags }),
      this.requestOptions
    );
  }

  escanearProcuracoes(id: number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'escanear-procuracoes',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  moverLista(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'mover-lista',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  getSheet(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'get-sheet',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  addSheet(id: number, data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'add-sheet',
      JSON.stringify({ id, data }),
      this.requestOptions
    );
  }

  deleteSheet(id: number, name: string) {
    return this.http.post<any>(
      environment.apiEndpoint + 'delete-sheet',
      JSON.stringify({ id, name }),
      this.requestOptions
    );
  }

  renameSheet(id: number, atual: string, novo: string) {
    return this.http.post<any>(
      environment.apiEndpoint + 'rename-sheet',
      JSON.stringify({ id, atual, novo }),
      this.requestOptions
    );
  }

  updateSheet(id: number, name: string, data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'update-sheet',
      JSON.stringify({ id, name, data }),
      this.requestOptions
    );
  }

  header() {
    return this.http.post<any>(
      environment.apiEndpoint + 'header',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  footer() {
    return this.http.post<any>(
      environment.apiEndpoint + 'footer',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  atualizarHeader(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'atualizar-header',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  atualizarFooter(data: any) {
    return this.http.post<any>(
      environment.apiEndpoint + 'atualizar-footer',
      JSON.stringify(data),
      this.requestOptions
    );
  }

  fetchConfiguracoes() {
    return this.http.post<any>(
      environment.apiEndpoint + 'fetchConfiguracoes',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  cor() {
    return this.http.post<any>(
      environment.apiEndpoint + 'cor',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  atualizarCor(cor: string) {
    return this.http.post<any>(
      environment.apiEndpoint + 'atualizar-cor',
      JSON.stringify({ cor }),
      this.requestOptions
    );
  }

  reprocessar(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'reprocessar',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  reprocessar_analise(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'reprocessar-analise',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  chat(data: any) {
    const formData = new FormData();

    Object.entries(data).forEach((value: any) => {
      formData.append(value[0], value[1]);
    })

    const headers = {
      'enctype': 'multipart/form-data',
    };

    return this.http.post<any>(
      environment.apiEndpoint + 'chat',
      formData,
      {
        headers: new HttpHeaders(headers),
      }
    );
  }

  perguntasList() {
    return this.http.post<any>(
      environment.apiEndpoint + 'conhecimento-list',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  fetchPergunta(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-pergunta',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  arquivosList() {
    return this.http.post<any>(
      environment.apiEndpoint + 'arquivos-list',
      JSON.stringify({}),
      this.requestOptions
    );
  }

  fetchArquivo(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'buscar-arquivo',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }

  baixarArquivo(id: Number) {
    return this.http.post<any>(
      environment.apiEndpoint + 'baixar-arquivo',
      JSON.stringify({ id }),
      this.requestOptions
    );
  }







  loggedIn() {
    return !!localStorage.getItem('botway');
  }

  getToken() {
    if (this.loggedIn()) {
      return JSON.parse(localStorage.getItem('botway')!)['token'];
    }
    return null;
  }

  getNome() {
    if (this.loggedIn()) {
      return JSON.parse(localStorage.getItem('botway')!)['nome'];
    }
    return null;
  }

  getEscritorio() {
    if (this.loggedIn()) {
      return [JSON.parse(localStorage.getItem('botway')!)['escritorio_id'], JSON.parse(localStorage.getItem('botway')!)['escritorio']];
    }
    return null;
  }

  setEscritorio(id: Number, nome: string) {
    if (this.loggedIn()) {
      let tmp = JSON.parse(localStorage.getItem('botway')!);
      tmp['escritorio_id'] = id;
      tmp['escritorio'] = nome;

      localStorage.setItem('botway', JSON.stringify(tmp));
    }
  }

  checarPermissao(permissao: string) {
    let p = JSON.parse(localStorage.getItem('botway')!);
    p = JSON.parse(p['permissoes']);
    for (const i of p) {
      if (i == permissao) {
        return [true, 'grant'];
      }
    }
    p = JSON.parse(localStorage.getItem('botway')!);
    if (Number(p['master']) === 1) return [true, 'master'];
    return [false, 'false'];
  }
}
